module.exports = __webpack_public_path__ + "static/media/mrt.6d854e9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mapIcons/mrt.svg
// module id = 2564
// module chunks = 2